export default __webpack_public_path__ + "images/BG.28228ed.png";